import { interval } from 'rxjs'
import { mergeMap, map, takeUntil, filter, startWith, takeWhile } from 'rxjs/operators'
import { ofType, ActionsObservable, StateObservable } from 'redux-observable'
import { ReduxAction, State } from '../../../reducers/reducerType'
import usernameLib from '../../../../lib/username'
import { roomTypes } from '../../../actions/room/roomTypes'
import { setupTypes } from '../../../actions/setup/setupTypes'
import { getAudienceMessage } from '../../../slices/messaging/messagingSlice'
import { terminateGig } from '../../../actions/gig/gigActions'
import { ActionCreatorWithoutPayload } from '@reduxjs/toolkit'

const announcementsPolling$ = (action$: ActionsObservable<ReduxAction | ActionCreatorWithoutPayload>, state$: StateObservable<State>) => action$.pipe(
  ofType(setupTypes.SET_ROOM),
  takeWhile(() => state$.value.config.featureFlags.announcements),
  filter(() =>
    usernameLib.isPresenter(state$.value.config.username || '') ||
    usernameLib.isObserver(state$.value.config.username || '')
  ),
  mergeMap(() => {

    return interval(10000).pipe(
      takeUntil(
        action$.pipe(
          ofType<
            ReduxAction<any> | ActionCreatorWithoutPayload<string>,
            any,
            string | roomTypes.TEAR_DOWN_ROOM_SUCCESS
          >(roomTypes.TEAR_DOWN_ROOM_SUCCESS, terminateGig().type)
        )
      ),
      startWith(() => getAudienceMessage(state$.value.config.roomname || '')),
      map(() => getAudienceMessage(state$.value.config.roomname || ''))
    )

  })
)

export default announcementsPolling$
